import { Avatar } from '@design-systems/canvas-ui'
import Icon, { PersonIcon } from '@design-systems/react-icons'
import { getColor } from '@plm-core/utils'
import {
  getUserDisplayName,
  getUserInitials,
} from 'users/utils/userDisplayHelpers'

type Props = {
  firstName: string
  lastName: string
  lanId: string
}

type CanvasAvatarProps = Omit<
  React.ComponentProps<typeof Avatar>,
  'color' | 'children'
>

const UserAvatar = ({
  firstName,
  lastName,
  lanId,
  'aria-label':
    ariaLabel = `avatar for ${getUserDisplayName(firstName, lastName)}`,
  ...rest
}: Props & CanvasAvatarProps) => {
  const firstInitial =
    typeof firstName === 'string' && firstName.length ? firstName[0] : ''
  const secondInitial =
    typeof lastName === 'string' && lastName.length ? lastName[0] : ''

  const isAnonymous = !firstInitial && !secondInitial

  const backgroundColor = isAnonymous ? 'default' : getColor(lanId)

  return (
    <Avatar aria-label={ariaLabel} color={backgroundColor} {...rest}>
      {!isAnonymous && getUserInitials(firstName, lastName)}
      {isAnonymous && <Icon svg={PersonIcon} />}
    </Avatar>
  )
}

export default UserAvatar
